import * as helpers from 'dom-lib';
import isElement from './isElement';
export * from 'dom-lib';

const DOMHelper = {
  ...helpers,
  isElement
};

export default DOMHelper;
